/** Compute nice Y-axis tick values starting at 0. */
import { formatModalityDisplayLabel } from '../../utils/modalityUtils';

export function computeNiceTicks(maxValue: number, tickCount = 4): number[] {
  if (!Number.isFinite(maxValue) || maxValue <= 0) {
    return [1, 0];
  }
  const rawStep = maxValue / tickCount;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const normalized = rawStep / magnitude;
  let niceStep: number;
  if (normalized <= 1) {
    niceStep = magnitude;
  } else if (normalized <= 2) {
    niceStep = 2 * magnitude;
  } else if (normalized <= 5) {
    niceStep = 5 * magnitude;
  } else {
    niceStep = 10 * magnitude;
  }

  const ticks: number[] = [];
  for (let v = 0; v <= maxValue + niceStep * 0.01; v += niceStep) {
    ticks.push(Math.round(v));
    if (ticks.length > tickCount + 1) {
      break;
    }
  }
  if (ticks[ticks.length - 1] < maxValue) {
    ticks.push(Math.round(ticks[ticks.length - 1] + niceStep));
  }
  return ticks.reverse();
}

export function formatDurationMinutes(totalMinutes: number): string {
  if (!Number.isFinite(totalMinutes) || totalMinutes < 0) {
    return '—';
  }
  const minutes = Math.round(totalMinutes);
  if (minutes < 60) {
    return `${minutes}m`;
  }
  const hours = Math.floor(minutes / 60);
  const rem = minutes % 60;
  if (rem === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${rem}m`;
}

export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) {
    return '0';
  }
  return new Intl.NumberFormat('en-IN').format(value);
}

export function formatPercent(value: number): string {
  if (!Number.isFinite(value)) {
    return '0%';
  }
  return `${Math.round(value)}%`;
}

export function modalityDisplayName(code: string): string {
  const key = String(code || '').trim();
  if (!key) {
    return '—';
  }
  return formatModalityDisplayLabel(key);
}
